import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Modal from "./Modal";
import { useEffect } from "react";
import { setCookieBase64 } from "./setCookieBase64";
import { IoBagCheckOutline } from "react-icons/io5";
import constants from "../helpers/constants";
import getApiHeaders from '../helpers/apiHeaders.js';

const CheckoutSuccess = () => {
    const { t } = useTranslation();
    const { access } = useParams();

    useEffect(() => {
        const updateSession = async () => {
            try {
                const response = await fetch(
                    `${constants.fetchAuthRefresh}`,
                    { headers: getApiHeaders(), credentials: "include" });
                    
                if (response.ok) {
                    const result = await response.json();
                    setCookieBase64("auth", result, { days: 1 })
                }
            } catch (error) {
                console.error("Error fetching graph from server:", error);
            }
        }
        updateSession();
    }, [])

    if (!access) {
        return;
    }

    return (
        <Modal title={t('checkout.title')} hideCloseButton={true}>
            <div className="login-modal">
                <div className="login-modal-container">
                    <div className="d-flex">
                        <h1 className="me-2 mt-1"><IoBagCheckOutline /></h1>
                        <h1>{t('checkout.paymentSuccess')}</h1>
                    </div>
                    <p style={{ padding: '2em', textAlign: 'center' }}>{t('checkout.accessUpgraded', { access })}</p>
                    <button onClick={() => { window.location = '/' }} className="highlight">{t('common.continue')}</button>
                </div>
            </div>
        </Modal>
    )
}
export default CheckoutSuccess